export default {
  names: {
    female: [
      'Alrun',
      'Arnhild',
      'Astrid',
      'Bodil',
      'Botilde',
      'Borghild',
      'Borglinde',
      'Brynhild',
      'Dagmar',
      'Didda',
      'Elborg',
      'Eldrid',
      'Erika',
      'Frida',
      'Frideborg',
      'Gudrun',
      'Gunhild',
      'Gunvor',
      'Helga',
      'Hilda',
      'Hildeborg',
      'Holda',
      'Ida',
      'Inga',
      'Inge',
      'Ingeborg',
      'Ingrid',
      'Ragnhild',
      'Randi',
      'Rigborg',
      'Rikke',
      'Sighild',
      'Signe',
      'Signi',
      'Signild',
      'Sigrid',
      'Solveig',
      'Solvej',
      'Svanhilde',
      'Svenborg',
      'Svenhild',
      'Svenja',
      'Sunniva',
      'Thorgard',
      'Tove',
      'Vilma',
      'Vilhelmine',
    ],
    male: [
      'Alvin',
      'Arild',
      'Arnald',
      'Arnbjörn',
      'Arne',
      'Arnketil',
      'Arnulf',
      'Arnvald',
      'Arvid',
      'Asbjörn',
      'Asgeir',
      'Asketill',
      'Aslak',
      'Asulf',
      'Bertil',
      'Biarni',
      'Bjarni',
      'Björnulf',
      'Björn',
      'Brand',
      'Brynjolf',
      'Einar',
      'Eivind',
      'Erik',
      'Erling',
      'Eskil',
      'Folker',
      'Folmer',
      'Frederik',
      'Freerik',
      'Frithjof',
      'Frode',
      'Germund',
      'Grim',
      'Gudbjörn',
      'Gudmund',
      'Gunnar',
      'Gunnolf',
      'Gustaf',
      'Hagbard',
      'Hagen',
      'Hakon',
      'Haldor',
      'Halfdan',
      'Halfred',
      'Halvard',
      'Halvor',
      'Harald',
      'Hastein',
      'Havard',
      'Helge',
      'Helgi',
      'Henning',
      'Henrik',
      'Herluf',
      'Hermod',
      'Herulf',
      'Hilding',
      'Hilmar',
      'Hjalmar',
      'Holger',
      'Holmgeir',
      'Hrolf',
      'Ingemann',
      'Ingmar',
      'Ingolf',
      'Ingvald',
      'Ingvar',
      'Karl',
      'Ketil',
      'Kjeld',
      'Knud',
      'Knut',
      'Odomar',
      'Olaf',
      'Ole',
      'Olof',
      'Olrik',
      'Oluf',
      'Ralf',
      'Ragnar',
      'Ragnvald',
      'Ranulf',
      'Roald',
      'Rolf',
      'Runi',
      'Rurik',
      'Siger',
      'Sigfred',
      'Sigmund',
      'Sigurd',
      'Sigvald',
      'Sigvard',
      'Skeggi',
      'Stig',
      'Stigand',
      'Svarting',
      'Svein',
      'Svend',
      'Svenn',
      'Svenning',
      'Sverre',
      'Thorbjörn',
      'Thorfrid',
      'Thorgeir',
      'Thorgis',
      'Thorkel',
      'Thorketil',
      'Thorkil',
      'Thorlak',
      'Thorleif',
      'Thormod',
      'Thorolf',
      'Thorstein',
      'Thorvald',
      'Ulf',
      'Ulv',
      'Valter',
      'Veland',
      'Vemund',
      'Vilfrid',
      'Wilhjelm',
    ],
  },
};



// WEBPACK FOOTER //
// ./src/data/names.ts